import React, { useState, useEffect, useCallback } from "react";
import "../../static/css/App.css";
import { Container, Button, Row, Col, Modal, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../static/css/customerTable.css";
import moment from "moment";
import { Box } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { showConfirm } from "react-confirm-prompt";
import DynamicBreadcrumb from "../header/breadcrumb";
import productAPI from "../../services/productapi";
import Loader from "../loader/loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import ProductStockModal from "./ProductStockModal";
import DownloadInventoryCsv from "../components/DownloadInventoryCsv";
import { ToastContainer } from "react-toastify";
import { CatalogHeader, CatalogToolbar } from "../../components/catalog/CatalogUI";
library.add(fas);

const ItemsList = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [totalProduct, setTotalProduct] = useState(0);
    const [refreshTable, setRefreshTable] = useState(false);
    const [sortModel, setSortModel] = useState([]);
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 15,
    });
    const [openModal, setOpenModal] = useState(false);
    const [notesText, setNotesText] = useState("Enter Reason");
    const [errors, setErrors] = useState({});
    const [closeNotes, setCloseNotes] = useState("");
    const [productId, setProductId] = useState(null);
    const [invModal, setInvModal] = useState(false);
    const [productStatus, setProductStatus] = useState(null);
    const [loaderVisible, setLoaderVisible] = useState(false);

    const navigate = useNavigate();
    const pathArray = [
        {
            name: "Products Variants",
            url: null,
        },
    ];

    const fetchProducts = useCallback(async () => {
        setLoading(true);
        try {
            const { page, pageSize } = paginationModel;
            // console.log(filterModel,'filterModel');
            const data = await productAPI.getAllProductItems({
                limit: pageSize,
                page,
                sortModel,
                filterModel,
            });

            const formattedRows = data.data.result.map((cust, index) => ({
                id: cust.id,
                sno: page * pageSize + index + 1,
                item_updateddate: moment(cust.updatedAt).format("YYYY/MM/DD kk:mm:ss"),
                item_syncdate: moment(cust.syncDate).format("YYYY/MM/DD kk:mm:ss"),
                name: cust.productName,
                brandName: cust.brandName,
                itemName: cust.spec + ' ' + cust.unit,
                categoryName: cust.CategoryName,
                itemImage: cust.itemImages ?? "",
                status: cust.status,
                ref_code: cust.refCode
            }));
            setRows(formattedRows);
            setTotalProduct(data.data.totalRecords[0].total_records || 0);
        } catch (error) {
            console.error("Failed to fetch Product:", error);
        } finally {
            setLoading(false);
        }
    }, [paginationModel, sortModel, filterModel, refreshTable]);

    useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);

    const handleStatusClick = (productId, status) => {
        const sureTxt =
            status === 1
                ? "Are you sure to change status to inactive?"
                : "Are you sure to change status to active?";
        const decTxt =
            status === 1
                ? "This will inactivate the product"
                : "This will activate the product";
        showConfirm(sureTxt, {
            description: decTxt,
            type: "info",
        }).then((answer) => {
            if (answer) {
                setProductId(productId);
                setProductStatus(status);
                if (status !== 1) {
                    submitUpdateDetails(productId, status);
                } else {
                    setOpenModal(true);
                }
            }
        });
    };


    const columns = [
        { field: "sno", headerName: "#", sortable: false, width: 64 },
        {
            field: "productDetails",
            headerName: "Product Name, Brand, Category",
            width: 300,
            renderCell: (params) => (
                <div>
                    <strong>{params.row.name}</strong><br />
                    <strong>{params.row.itemName}</strong>
                    <br />
                    {params.row.brandName && (
                        <><span>Brand: {params.row.brandName}</span> <br /></>
                    )}
                    {params.row.categoryName && (
                        <span>Category: {params.row.categoryName}</span>
                    )}
                </div>
            ),
        },
        {
            field: "ref_code",
            headerName: "Reference Code",
        },
        {
            field: "itemImage", headerName: "Image", flex: 1, renderCell: (params) => (
                <>
                    {params.value && params.value.split(",").length > 0 && (
                        <img
                            src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${params.value.split(",")[0]}`}
                            alt={params.value}
                            style={{ maxWidth: "80px", maxHeight: "60px", padding: "5px" }}
                        />
                    )}
                </>
            ),
        },
        { field: "item_updateddate", headerName: "Updated ON", },
        { field: "item_syncdate", headerName: "Synced ON", },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => (
                <Row>
                    <Col
                        key={params.id + "-status"}
                        className={"ms-2 p-2 me-2 d-grid gap-2"}
                    >
                        <button
                            onClick={() => handleStatusClick(params.id, parseInt(params.value))}
                            className={`catalog-status ${Number(params.value) === 1 ? "active" : "inactive"}`}
                            style={{ outline: "none", boxShadow: "none" }}
                        >
                            {params.value === 1 ? "Active" : "Inactive"}
                        </button>
                    </Col>
                </Row>
            ),
        },
        {
            field: "actions",
            headerName: "Price & Stock",
            sortable: false,
            flex: 1,
            renderCell: (params) => (
                <Row>
                    <Col
                        key={params.id + "-status"}
                        className={"ms-2 p-2 me-2 d-grid gap-2"}
                    >

                        <Button
                            className={"p-2 me-2 mb-1 "}
                            size="sm"
                            onClick={() => openViewModel(params.id)}
                        >
                            <FontAwesomeIcon
                                icon="fa-solid fa-eye"
                                size="sm"
                                style={{ color: "black" }}
                            />{" "}
                            Update
                        </Button>
                    </Col>
                </Row>
            ),
        },
    ];

    const openViewModel = (id) => {
        if (id !== null) {
            setProductId(id);
            setInvModal(true);
        }
    };

    const hideViewModal = () => {
        setProductId(null);
        setInvModal(false);
    };

    const validateCancelForm = () => {
        const newErrors = {};
        if (!closeNotes) newErrors.closeNotes = "Notes is required";
        return newErrors;
    };

    const handleInactivate = async (event) => {
        event.preventDefault();
        const formErrors = validateCancelForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            try {
                submitUpdateDetails(productId, productStatus, closeNotes);
            } catch (error) {
                setErrors({ common: "Update Failed" });
            }
        }
    };

    const submitUpdateDetails = async (productId, status, notes = null) => {
        try {
            let sendStatus = status === 1 ? 2 : 1;
            let params = {
                action: "status",
                status: sendStatus,
                productId: productId,
                reason: notes,
            };

            const resp = await productAPI.updateProductStatus(params, 'item');
            if (resp) {
                const message = resp.message || "Product status updated successfully";
                showConfirm("Success", {
                    description: message,
                    type: "Success",
                    hideCancel: true,
                }).then(() => {
                    setRefreshTable(!refreshTable);
                    setOpenModal(false);
                });
            } else {
                const message = "Process failed, kindly try again later!";
                showConfirm("Oops!", {
                    description: message,
                    type: "warning",
                    hideCancel: true,
                }).then(() => {
                    setRefreshTable(!refreshTable);
                    setOpenModal(false);
                });
            }
            handleClose();
        } catch (error) {
            showConfirm("Oops!", {
                description: "Process failed, kindly try again later!",
                type: "warning",
                hideCancel: true,
            });
            handleClose();
        }
    };

    const setReason = (e) => {
        setCloseNotes(e.target.value);
    };

    const handleClose = () => {
        setOpenModal(false);
        setNotesText("Enter Reason");
    };



    return (
        <Container fluid className="catalog-page">
            <Box className="d-flex justify-content-between align-items-center">
                <DynamicBreadcrumb pathArray={pathArray} classesName="col-7" />
            </Box>
            <CatalogHeader title="Price & Stock Updates" description="Search variants by product, brand, category or reference code. Update branch prices and stock." count={totalProduct}
                actions={<DownloadInventoryCsv />} />
            {loaderVisible && <Loader />}
             <ToastContainer position="top-right" autoClose={3000} />
            <Box>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowHeight={() => "auto"}
                    rowsPerPageOptions={[5, 10, 20]}
                    paginationMode="server"
                    rowCount={totalProduct}
                    loading={loading}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    sortingMode="server"
                    filterMode="server"
                    onSortModelChange={setSortModel}
                    onFilterModelChange={(model) => { setFilterModel(model); setPaginationModel((prev) => ({ ...prev, page: 0 })); }}
                    disableColumnFilter
                    disableRowSelectionOnClick
                    pageSizeOptions={[15, 25, 50, 100]}
                    autosizeOptions={{
                        columns: ["brandName", "productName", "status"],
                        includeOutliers: true,
                        includeHeaders: false,
                    }}
                    slots={{
                        toolbar: CatalogToolbar,
                    }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: true },
                        },
                    }}
                    onRowSelectionModelChange={(row) => {
                        setRowSelectionModel(row);
                    }}
                    rowSelectionModel={rowSelectionModel}
                    sx={{
                        [`& .${gridClasses.cell}`]: {
                            py: 0.5,
                        },
                    }}
                />
            </Box>

            {productId > 0 && (
                <ProductStockModal
                    productId={productId}
                    invModal={invModal}
                    change={hideViewModal}
                />
            )}

            <Modal show={openModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title> Enter Reason</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="cancelForm">
                        <Form.Group className="mb-3" controlId="closeNotes">
                            <Form.Label>Enter inactivate reason</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={closeNotes}
                                onChange={setReason}
                                isInvalid={!!errors.closeNotes}
                            />
                        </Form.Group>
                        <Form.Control.Feedback type="invalid">
                            {errors.closeNotes}
                        </Form.Control.Feedback>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleInactivate}>
                        Submit Reason
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};


export default ItemsList;
